// import { useState } from "react";

// // react-router components
// import { Routes, Route, Navigate } from "react-router-dom";

// // @mui material components
// import { ThemeProvider } from "@mui/material/styles";
// import CssBaseline from "@mui/material/CssBaseline";

// import Sidenav from "examples/Sidenav";

// import theme from "assets/theme";

// import routes from "routes";

// import { useMaterialUIController } from "context";

// // Images
// import brand from "assets/images/favicon.png";

// import SignIn from "layouts/authentication/sign-in";
// import { useAuth } from "context/AuthContext"; // <-- add this
// import PrivateRoute from "components/PrivateRoute";

// export default function App() {
//   const [controller] = useMaterialUIController();
//   const { sidenavColor } = controller;
//   const [onMouseEnter, setOnMouseEnter] = useState(false);

//   const { isAuthenticated } = useAuth();

//   const getRoutes = (allRoutes) =>
//     allRoutes.map((route) => {
//       if (route.collapse) {
//         return getRoutes(route.collapse);
//       }

//       if (route.route) {
//         return (
//           <Route
//             exact
//             path={route.route}
//             element={<PrivateRoute>{route.component}</PrivateRoute>}
//             key={route.key}
//           />
//         );
//       }

//       return null;
//     });

//   return (
//     <ThemeProvider theme={theme}>
//       <CssBaseline />
//       {isAuthenticated && (
//         <>
//           <Sidenav
//             color={sidenavColor}
//             brand={brand}
//             brandName="Twister"
//             routes={routes}
//             onMouseEnter={() => !onMouseEnter && setOnMouseEnter(true)}
//             onMouseLeave={() => onMouseEnter && setOnMouseEnter(false)}
//           />
//         </>
//       )}
//       <Routes>
//         <Route path="/authentication/sign-in" element={<SignIn />} />

//         {getRoutes(routes)}

//         <Route
//           path="/"
//           element={
//             isAuthenticated ? (
//               <Navigate to="/dashboard" replace />
//             ) : (
//               <Navigate to="/authentication/sign-in" replace />
//             )
//           }
//         />
//       </Routes>
//     </ThemeProvider>
//   );
// }
import { useState } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

import theme from "assets/theme";
import routes from "routes";
import { useMaterialUIController } from "context";

import Sidenav from "examples/Sidenav";
import brand from "assets/images/favicon.png";

import SignIn from "layouts/authentication/sign-in";
import { useAuth } from "context/AuthContext";
import PrivateRoute from "components/PrivateRoute";


export default function App() {
  const [controller] = useMaterialUIController();
  const { sidenavColor } = controller;
  const [onMouseEnter, setOnMouseEnter] = useState(false);

  const { isAuthenticated } = useAuth();
  const location = useLocation();

  // Hide sidenav on sign-in page
  const hideSidenav =
    location.pathname.startsWith("/authentication/sign-in");

  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.collapse) return getRoutes(route.collapse);

      if (route.route) {
        return (
          <Route
            exact
            path={route.route}
            element={
              <PrivateRoute>{route.component}</PrivateRoute>
            }
            key={route.key}
          />
        );
      }
      return null;
    });

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />

      {/* Show sidenav ONLY if logged in AND not on sign-in page */}
      {isAuthenticated && !hideSidenav && (
        <Sidenav
          color={sidenavColor}
          brand={brand}
          brandName="Twister"
          routes={routes}
          onMouseEnter={() => !onMouseEnter && setOnMouseEnter(true)}
          onMouseLeave={() => onMouseEnter && setOnMouseEnter(false)}
        />
      )}

      <Routes>
        {/* Public Route */}
        <Route path="/authentication/sign-in" element={<SignIn />} />

        {/* Redirect Root */}
        <Route
          path="/"
          element={
            isAuthenticated
              ? <Navigate to="/dashboard" replace />
              : <Navigate to="/authentication/sign-in" replace />
          }
        />

        {/* Protected Routes */}
        {getRoutes(routes)}

        {/* Fallback */}
        <Route
          path="*"
          element={
            isAuthenticated
              ? <Navigate to="/dashboard" replace />
              : <Navigate to="/authentication/sign-in" replace />
          }
        />
      </Routes>
    </ThemeProvider>
  );
}
